import { createContext, useContext } from 'react';
import type { Views, WeekStart } from './helpers';

type DatepickerContextProps = {
  language: string;
  weekStart: WeekStart;
  minDate?: Date;
  maxDate?: Date;
  rangeStart?: Date;
  rangeEnd?: Date;
  isOpen?: boolean;
  setIsOpen: (isOpen: boolean) => void;
  view: Views;
  setView: (value: Views) => void;
  selectedDate: Date;
  setSelectedDate: (date: Date) => void;
  changeSelectedDate: (date: Date, useAutohide: boolean) => void;
  viewDate: Date;
  setViewDate: (date: Date) => void;
};

export const DatepickerContext = createContext<
  DatepickerContextProps | undefined
>(undefined);

export function useDatePickerContext(): DatepickerContextProps {
  const context = useContext(DatepickerContext);

  if (!context) {
    throw new Error(
      'useDatePickerContext should be used within the DatePickerContext provider!'
    );
  }

  return context;
}
